import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(Storefront)/(Shop)/(E-commerce)/special/[slug]/page.components.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useForm","useValidator"] */ "/vercel/path0/data/forms/hooks.js");
;
import(/* webpackMode: "eager", webpackExports: ["useScroll"] */ "/vercel/path0/data/scroll/hooks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/hooks/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["Configure"] */ "/vercel/path0/opensearch/components/Configure.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchBox"] */ "/vercel/path0/opensearch/components/SearchBox.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/opensearch/context/OpenSearchContext.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/opensearch/context/OpenSearchProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/opensearch/hooks/index.ts");
